import React from 'react'
import { Link } from 'react-router-dom';
import { MdAddShoppingCart } from 'react-icons/md';

export default () => (
  <div className='empty_state'>
    <div className="empty-image">
      <MdAddShoppingCart className='icon'/>
    </div>
    <div className="title">Your Shopping Cart is empty.</div>
    <div className="caption">
      Continue shopping on the &nbsp;
      <Link to='/home'>Homepage</Link>,
      to learn more about today's deals.
    </div>
  </div>
);
